import { ThemeEvents } from '@theme/events';

/**
 * Re-runs the Tabby "pay later" app block's own init script after a variant change.
 *
 * That script (injected by the Tabby app block) tries to re-render itself on variant
 * changes via its own listeners: a `change` listener on a `<select>` (this theme uses
 * button/swatch variant pickers, so there is none) and a MutationObserver watching the
 * hidden `input[name="id"]`'s `value` *attribute* (the theme updates the `.value`
 * *property*, which doesn't trigger that observer even after mirroring the attribute —
 * the widget's internal re-init still doesn't reliably repopulate `#TabbyPromo`). Net
 * result: the widget shows on first load, then goes permanently blank after any size
 * is picked.
 *
 * Rather than reverse-engineer/replicate Tabby's internal render call (which would
 * duplicate their public key and config, and drift if they change their script), this
 * simply re-executes their own inline script verbatim — cloning it into a fresh
 * <script> element forces the browser to run it again, exactly as if the page had
 * reloaded, using their real logic and config every time.
 */
function findTabbyScript() {
  const promo = document.getElementById('TabbyPromo');
  const block = promo?.closest('.shopify-app-block');
  return block?.querySelector('script') ?? null;
}

function rerunTabbyScript() {
  const script = findTabbyScript();
  if (!script) return;

  const fresh = document.createElement('script');
  for (const { name, value } of Array.from(script.attributes)) {
    fresh.setAttribute(name, value);
  }
  fresh.textContent = script.textContent;
  script.replaceWith(fresh);
}

document.addEventListener(ThemeEvents.variantUpdate, rerunTabbyScript);
